import React, { Component } from "react";
import Stocks from '../../api/Stock';
import "./CountStock.css";

class CountStock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: []
        }
    }

    componentDidMount() {
        Stocks.get('/get-stock-count')
            .then(res => {
                this.setState({ count: res.data })
            })
            .catch(error => console.log(error));
    }

    render() {
        return (
            <div className="count-main-stock">
                <div className="stock-title">
                    TODAY'S  STOCKS<br />ADDED :
                </div>
                <div>
                    <span className="count-stock">{this.state.count}</span>
                </div>


            </div>
        )
    }
}

export default CountStock;